const traduction = {
  common: {
    next: "Next",
    cancel: "Cancel",
  },
  forgetPassword: {
    title: "Reset your password",
    EmailPlaceholder: "Email address*",
    buttonRest:'Reset password',
    buutonBack:'Back to Login',
    successMessage:'Password Reset !',
    sigin:'Sign In'
  },
  activation:{
    title:'Activate your account',
    go:'Go to dashboard',
    back:'Back to login',
    confirm:'Confirm your identity',
    successMessage:'Your account is activated !',
  
  },

  logOut: {
    logIn: "Sign in to",
    register: "Register",
  },
  logIn: {
    title: "Join TAWA community now.",
    logIn: "Sign in to",
    EmailPlaceholder: "Email address*",
    PasswordPlaceholder: "Password*",
    ForgetPassword: "Forget password ?",
    "Sign-in": " Sign in ",
    "have-not-account": "Don't have an account ?",
    "create-account": "Create free account",
    
      emailRequired: "Email is required",
      emailValidation: "Email is invalid",
      passwordRequired: "Password is required",
      passwordValidation: "Password must be at least 6 characters",
      agencyName: "Agency name is required",
      socialMedia: "Insert at least one social media username",
    
  },
  SignUp: {
    title: "Sign up for free",
    button: {
      creator: "Creator",
      advertiser: "Advertiser",
      SignUp: "Sign Up for free",
      SignIn: "Sign In",
    },
    radioButton: {
      title: "You are :",
      brand: "Brand",
      agency: "Agency",
    },
    FormInput: {
      placeholder: {
        name: "Agency/Brand name*",
        instgram: "Instagram",
        tiktok: "Tiktok",
        email: "Email address*",
        password: "Password*",
        confirmPassword: "Confirm password*",
      },
    },
    "have-not-account": "Don't have an account ?",
    "agree-message-simple": "I agree to the",
    "agree-message-bold": "user agreement and privacy policy.",
    
      emailRequired: "Email is required",
      emailValidation: "Email is invalid",
      agencyName: "Agency name is required",
      socialMedia: "Insert at least one social media username",
      activationEmail: "Please check your email to validate",
      activationAccount: "your account.",
      passwordRequired: "Password is required",
      passwordValidation1: "Password must be at least 6 characters",
      passwordValidation2: "Password must be at most 24 characters",
      passwordValidation3:"Password must contain at least one uppercase letter",
      passwordValidation4: "Password cannot contain spaces",
      passwordStrong: "Password is strong",
      passwordValidation5:"Repeat the password in order to confirm it",
      passwordValidation6:"Passwords must match",
      passwordValidation7:"Passwords Confirmed",
      phoneValidation1:"only-numbers",
      phoneValidation2:"Phone must contain only numbers",
      termsRequired:"must accept terms"  

    
  },
};
export default traduction;
